// Здесь содержатся функции для подготовки и настройки модулей для работы с баннерами

import {getStateId} from '../../modules/pageCtxGlobal';

import {setCurrentStateGetter} from './util/BannerCommon';
import {type IBannerStatLogger, setBannerStatLogger} from './util/BannerStat';

export function prepareBannerStatLogger(logger: IBannerStatLogger) {
    setBannerStatLogger(logger);
}

export function prepareCurrentStateGetter() {
    setCurrentStateGetter(getStateId);
}

export interface IPrepareSettings {
    statLogger?: IBannerStatLogger;
}

export function prepare(settings: IPrepareSettings) {
    if (settings.statLogger) {
        prepareBannerStatLogger(settings.statLogger);
    }
    prepareCurrentStateGetter();
}
